/* eslint-disable no-unused-vars */
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { HiHome } from "react-icons/hi";
import { HiArrowNarrowLeft } from "react-icons/hi";


import Prptypes from "prop-types";

import { Button } from "@mui/material";
import { DraftContext } from "./context/DraftContext";
import { DraftForms } from "./components/form-container/FormContainer";

import { TYPES } from "../../config/constants/typesReducers";
import { removeMimeType } from "../../ui/utils/removeMimeType";

import { getIdFromPath } from "../../ui/utils/getIdFromPath";
import { getDraft } from "./context/DraftReducer";
import { FddApi } from "../../ui/services/server-fdd";
import { PDFViewer } from "../../ui/components/PDFViewer";

import { PageSizeProvider } from "../../ui/context/page/PageSizeProvider";

import { LuFileEdit } from "react-icons/lu";
import { LoaderContext } from "../../ui/context/loader/LoaderContext";
import { useCallback } from "react";

import "../../ui/styles/pages/Draft.css";
import MODULES from "../../config/constants/modules";
import { STATUS_MODULE, STATUS_VIEWER } from "../../config/constants/status";

const { DRAFT } = TYPES;
const { LOADER } = TYPES;

export const Draft = ({ originalFilename }) => {  
  const location = useLocation();
  const navigate = useNavigate();
  const draftPageRef = useRef(null);

  const { draftState: { draft } , draftDispatch } = useContext(DraftContext);

  const { loaderDispatch } = useContext(LoaderContext);
  const [statusDraft, setStatusDraft] = useState(STATUS_MODULE.IDLE);
  const [statusViewer, setStatusViewer] = useState(STATUS_VIEWER.IDLE);

  const [document, setDocument] = useState(null);

  useEffect(() => {
    switch (statusDraft) {
      case STATUS_MODULE.IDLE: return loaderDispatch({type: LOADER.START, payload: 'Cargando borrador...'});
      case STATUS_MODULE.LOADED: return loaderDispatch({type: LOADER.LOADED});
      case STATUS_MODULE.ERROR: return loaderDispatch({type: LOADER.ERROR, payload: 'Error al cargar el borrador'});
    }
  }, [statusDraft, loaderDispatch]);

  const onChangeField = ({target}) => {
    const action = {
      type: DRAFT.TITLE,
      payload: target.value
    }

    draftDispatch(action);
  }

  const fetchDocument = useCallback(() => {
    const draftId = getIdFromPath(location.pathname);

    setStatusViewer(STATUS_VIEWER.IDLE);

    FddApi.getDocument(draftId, 'draft')
    .then((response) => {
      if (response.hasError) throw new Error(response.message);
      console.log('[DRAFT PAGE] Se ha cargado el documento');
      setDocument(response?.body);
    })
    .catch((error) => {
      console.log("[PDF Viewer] Error -> ", error);
      setStatusViewer(STATUS_VIEWER.ERROR);
    });
  }, [location.pathname]);


  const fetchDraft = useCallback(() => {
    const draftId = getIdFromPath(location.pathname);

    getDraft(draftId)
      .then((response) => {
        draftDispatch({
          type: DRAFT.LOAD_DRAFT,
          payload: response,
        });
      })
      .catch((error) => {
        console.log(
          "[DRAFT PAGE] No se encontro un draft anteriormente cargado ->",
          error
        );
        
        draftDispatch({
          type: DRAFT.TITLE,
          payload: removeMimeType(originalFilename),
        });
    });
    setStatusDraft(STATUS_MODULE.LOADED);

  }, [draftDispatch, location.pathname, originalFilename]);

  useEffect(() => {    
    fetchDraft();
    fetchDocument();

    return () => draftDispatch({ type: DRAFT.CLEAN });
    
  }, [draftDispatch, fetchDocument, fetchDraft]);
  
  return (
    <>
      {
        statusDraft !== STATUS_MODULE.IDLE &&
        <PageSizeProvider>
          <div ref={draftPageRef} className="draft">
            <div 
              className="draft__block-content" 
              style={{height: draft.title === '' ? '100%' : '0'}}/>
  
            <section 
              className="draft__header">
              <div className="mb-2">
                <Button
                  variant="text"
                  onClick={() => navigate('/')}
                  startIcon={
                    <HiArrowNarrowLeft />
                  }> Inicio
                </Button>
              </div>
              
              <div className="draft__title">
                <LuFileEdit className="draft__title--icon xxl-text"/>
                <input 
                  required
                  autoFocus
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  value={draft?.title}
                  onChange={onChangeField}
                  type="text"
                  className="draft__title--input xxl-text"
                  placeholder="Escribe un título para el borrador..."/>
              </div>
            </section>
  
            
            <div className="draft__container">
              <PDFViewer 
                status={statusViewer}
                setStatus={setStatusViewer}
                document={document} 
                fetchDocument={fetchDocument}
                module={MODULES.DRAFT}
                />
              <DraftForms parentRef={draftPageRef}/>
            </div>
          </div>
        </PageSizeProvider>
      }
    </>
  );
};

Draft.propTypes = {
  originalFilename: Prptypes.string,
};
